import React, { useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import Switch from 'react-switch';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';

const PersonaVencimientoModalContent = ({
	intl,
	onSave,
	onCancel,
	licencia,
}) => {
	const [formData, setFormData] = useState({
		fechaAlta: licencia && licencia.fecha_emision ? licencia.fecha_emision : null,
		fechaVencimiento: licencia && licencia.fecha_vencimiento ? licencia.fecha_vencimiento : null,
		numero: '',
		alertaDiasPrevios: 0,
		emisionDiasPrevios: 0,
		activo: true,
		renovacion: false,
	});

	const handleInputChange = (e) => {
		const { name, value, type, checked } = e.target;
		setFormData({
			...formData,
			[name]: type === 'checkbox' ? checked : value,
		});
	};

	const handleSwitchChange = (name, value) => {
		setFormData({ ...formData, [name]: value });
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		onSave(formData);
	};

	return (
		<form onSubmit={handleSubmit}>
			<div className="form-group">
				<label className="label-control col-form-label" htmlFor="numero" title={intl.formatMessage({ id: 'personaVencimientoModal.render.general_data.title_numero', defaultMessage: 'Número de identificación del vencimiento. Su ingreso es optativo.' })}>
					<FormattedMessage id="personaVencimientoModal.render.general_data.label_numero" defaultMessage="Número:"/>
				</label>
				<input type="text" className="form-control" id="numero" name="numero" placeholder="" value={formData.numero ? formData.numero : ''} onChange={handleInputChange} />
			</div>
			<div className="form-group">
				<label htmlFor="fechaAlta">
					<FormattedMessage id="personaVencimientoModal.render.vigencia.label_fecha_de_expedicion" defaultMessage="Fecha de Expedición"/> :
				</label>
				<DatePicker
					id="fechaAlta"
					name="fechaAlta"
					className="form-control date-picker-placeholder"
					placeholderText={intl.formatMessage({ id: 'personaVencimientoModal.render.general_data.placeholder_fecha_de_expedicion', defaultMessage: 'DD/MM/AAAA' })}
					selected={formData.fechaAlta ? moment(formData.fechaAlta) : null}
					dropdownMode="select"
					disabled={true}
					autoComplete="off"
				/>
			</div>
			<div className="form-group">
				<label htmlFor="fechaVencimiento">
					<FormattedMessage id="personaVencimientoModal.render.vigencia.label_fecha_de_vencimiento" defaultMessage="Fecha de Vencimiento"/> :
				</label>
				<DatePicker
					id="fechaVencimiento"
					name="fechaVencimiento"
					className="form-control date-picker-placeholder"
					placeholderText={intl.formatMessage({ id: 'personaVencimientoModal.render.general_data.placeholder_fecha_de_vencimiento', defaultMessage: 'DD/MM/AAAA' })}
					selected={formData.fechaVencimiento ? moment(formData.fechaVencimiento) : null}
					disabled={true}
					dropdownMode="select"
					autoComplete="off"
				/>
			</div>
			<div className="form-group">
				<label htmlFor="alertaDiasPrevios">
					<FormattedMessage id="personaVencimientoModal.render.avisos.label_primer_alerta" defaultMessage="Primer Alerta (dias antes):"/>
				</label>
				<input type="number" className="form-control" id="alertaDiasPrevios" name="alertaDiasPrevios" value={formData.alertaDiasPrevios} onChange={handleInputChange} />
			</div>
			<div className="form-group">
				<label htmlFor="emisionDiasPrevios">
					<FormattedMessage id="personaVencimientoModal.render.avisos.label_emision" defaultMessage="Emisión (dias antes):"/>
				</label>
				<input type="number" className="form-control" id="emisionDiasPrevios" name="emisionDiasPrevios" value={formData.emisionDiasPrevios} onChange={handleInputChange} />
			</div>
			<div className="form-group d-flex align-items-center">
				<label htmlFor="activo" className="mr-2">
					<FormattedMessage id="personaVencimientoModal.render.general_data.label_activo" defaultMessage="Activo"/>:
				</label>
				<Switch
					onChange={checked => handleSwitchChange('activo', checked)}
					checked={formData.activo}
					id="activo"
					name="activo"
					offColor="#FF4961"
					onColor="#28D094"
				/>
			</div>
			<div className="form-group d-flex align-items-center">
				<label htmlFor="renovacion" className="mr-2">
					<FormattedMessage id="personaVencimientoModal.render.general_data.label_renovacion" defaultMessage="Ejecución por única vez:"/>
				</label>
				<Switch
					onChange={checked => handleSwitchChange('renovacion', checked)}
					checked={formData.renovacion}
					id="renovacion"
					name="renovacion"
					offColor="#FF4961"
					onColor="#28D094"
				/>
			</div>
			<div className="text-right mt-3">
				<button type="submit"
					className="btn btn-primary mr-1"
					disabled={
						!formData.fechaAlta || !formData.fechaVencimiento
					}>
					<i className="fa fa-check-circle"></i> <FormattedMessage id="personaVencimientoModal.finish_button.generar_control" defaultMessage="Generar Control"/>
				</button>
				<button type="button" className="btn btn-danger" onClick={onCancel}>
					<i className="fa fa-times-circle"></i> <FormattedMessage id="personaVencimientoModal.finish_button.no_generar_control" defaultMessage="No Generar Control"/>
				</button>
			</div>
		</form>
	);
};

export default injectIntl(PersonaVencimientoModalContent);
